/**
 *
 * TextField
 *
 */

import * as PropTypes from "prop-types";
import styled, { css } from "styled-components";
import TextInput from "basicComponents/TextInput/TextInput";

export default function TextField(props) {
  return (
    <TextInput
      input={StyledTextField}
      dropDownEnableSearch={props.dropDownEnableSearch}
      {...props}
    />
  );
}

TextField.propTypes = {
  noPadding: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  variant: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  minW: PropTypes.number,
  minH: PropTypes.number,
  value: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  multiline: PropTypes.bool,
  rowsMax: PropTypes.number,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  keepPlaceholder: PropTypes.bool,
  focusTextField: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  dropDownEnableSearch: PropTypes.bool,
};

TextField.defaultProps = TextInput.defaultProps;

function borderColor({ theme, error, disabled }) {
  if (error) {
    return theme.palette.error.main;
  }
  if (disabled) {
    return theme.disabledColor;
  }
  return theme.borderColor;
}

function boxColor({ theme, error, disabled }) {
  if (error) {
    return theme.palette.error.main;
  }
  if (disabled) {
    return theme.disabledColor;
  }
  return theme.borderColor;
}
function padding({ noPadding }) {
  if (noPadding) {
    return css`
      padding-left: 10px;
      padding-bottom: 0.3rem;
    `;
  }
  return css`
    padding: 10px;
  `;
}

const StyledTextField = styled.input`
  ${({ dropDownEnableSearch }) =>
    dropDownEnableSearch && "margin-top: -1px; margin-left: -1px"};


  border: 1px solid ${borderColor};

  /* ${({ bottom }) => (bottom ? `border: unset;` : "")}; */

  ${({ fullWidth }) => (fullWidth ? "width: 100%;" : "")}
  ${({ dropDownEnableSearch, fullWidth }) =>
    dropDownEnableSearch && fullWidth && "width: calc(100% + 2px)"};+
  /* width: ${({ theme, width }) => width * theme.grid}rem; */


  /* width: calc(100% - 30px) */
  ${({ searchIcon }) =>
    searchIcon ? "width: 100%; margin-bottom: -1px" : "width: 100%"};


  height: ${({ theme, height }) => height * theme.grid}rem;
  line-height: ${({ theme, height }) => height * theme.grid}rem;
  ${({ minW }) => (minW ? `min-width: ${minW}rem;` : "")};
  ${({ minH }) => (minH ? `min-height: ${minH}rem;` : "")};


  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;

  color: ${boxColor};
  background: white;
  border-radius: 50px;
  text-align: left;
  ${padding};
  transition: border 0.2s;

  &::placeholder {
    color: ${({ theme }) => theme.borderColor};
  }

  &::-ms-clear {
    display: none;
  }

  &::-ms-reveal {
    display: none;
  }

  &:focus {
    outline: none;
  }

  /**
   * Disable the horrible blue color in chrome when the field was automatically filled
   */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }
`;
